import React, { Component } from 'react'
import Slider from 'react-slick'
import AriaModal from 'react-aria-modal'

import { customMaxWidth } from '../../../utils/responsiveUtils'
import { PriceCardsArrow } from '../../Icons/PriceCardsArrow'

import './index.global.scss'
import styles from './styles.module.scss'
import {
  PrevArrowSection,
  NextArrowSection,
  PriceCardSvgContainer,
  PriceCardNextSvgContainer,
  CardItemContainer,
  CardContainer,
  CardImage,
  DesktopSlider,
  DesktopCardsWrapper,
  PriceCardsSection,
  PriceCardsContainer,
  SliderContainer,
  KnowMoreButton,
  MembershipCardImage,
  ImageContentContainer,
  PointContentWrapper,
  Point,
  VisitText,
  CloseButton,
  CloseImage
} from './styledComponents'

class DesktopPriceCards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      testimonialIndex: 0,
      testimonialMaxIndexLimit: 1,
      modalStatus: false
    }
  }
  componentDidMount() {
    const { priceCardsData } = this.props
    const { priceCardsDesktopImagesList } = priceCardsData
    // const { testimonialsList } = testimonialsDataProps
    if (customMaxWidth(1101)) {
      // TODO: At this break point 1100, In the slick we need to change the number of cards to be displayed for proper alignment.
      // eslint-disable-next-line
      this.setState({
        testimonialMaxIndexLimit: priceCardsDesktopImagesList.length - 1
      })
    } else {
      // eslint-disable-next-line
      this.setState({
        testimonialMaxIndexLimit: priceCardsDesktopImagesList.length - 3
      })
    }
  }
  next = () => {
    this.slider.slickNext()
  }
  previous = () => {
    this.slider.slickPrev()
  }
  dragging = e => {
    e.preventDefault()
  }
  testimonialStopSliding = index => {
    this.setState({
      testimonialIndex: index
    })
  }

  handleClick = () => {
    this.setState({ modalStatus: true })
  }

  onHideModal = () => {
    this.setState({ modalStatus: false })
  }

  renderMembershipModal = ({
    imageUrl,
    imageAltText,
    visitArcadeText,
    packageText
  }) => {
    const { modalStatus } = this.state
    return (
      <AriaModal
        titleId="custom-modal"
        underlayClass={styles.dialogStyle}
        focusDialog
        mounted={modalStatus}
        onExit={this.onHideModal}
        ariaHideApp={false}
      >
        <CloseButton
          type="button"
          className={styles.closeButton}
          aria-label="Close"
          onClick={this.onHideModal}
        >
          <CloseImage
            src="https://cdn.zeplin.io/5b9ba4851a546d689032f416/assets/11D7F9E7-5526-4A37-B8F9-3A3AD77CA0C2.svg"
            alt="close-icon"
            id="close-icon-membership-card"
          />
        </CloseButton>
        <ImageContentContainer>
          <MembershipCardImage
            id={imageAltText}
            src={imageUrl}
            alt={imageAltText}
          />
          <PointContentWrapper>
            <Point />
            <VisitText>{visitArcadeText}</VisitText>
          </PointContentWrapper>
          {packageText ? (
            <PointContentWrapper>
              <Point />
              <VisitText>{packageText}</VisitText>
            </PointContentWrapper>
          ) : null}
        </ImageContentContainer>
      </AriaModal>
    )
  }

  render() {
    const { testimonialIndex, testimonialMaxIndexLimit } = this.state
    const { priceCardsData } = this.props
    const { priceCardsDesktopImagesList } = priceCardsData
    const testimonialsSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      afterChange: this.testimonialStopSliding,
      arrows: false,
      draggable: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            draggable: true
          }
        },
        {
          breakpoint: 1023,
          settings: {
            infinite: false,
            autoplay: false,
            slidesToShow: 2.5,
            slidesToScroll: 1,
            arrows: false,
            draggable: true
          }
        },
        {
          breakpoint: 1162,
          settings: {
            infinite: false,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            draggable: true
          }
        }
      ]
    }
    return (
      <PriceCardsSection>
        <PriceCardsContainer>
          {priceCardsDesktopImagesList.length > 3 ? (
            <SliderContainer>
              <PrevArrowSection
                onClick={this.previous}
                id="price-card-previous-arrow"
              >
                <PriceCardSvgContainer disableArrow={testimonialIndex === 0}>
                  <PriceCardsArrow />
                </PriceCardSvgContainer>
              </PrevArrowSection>
              <DesktopSlider>
                <Slider
                  ref={c => {
                    this.slider = c
                  }}
                  className="PriceCardsSlickSection"
                  {...testimonialsSettings}
                >
                  {priceCardsDesktopImagesList.map(
                    ({
                      imageUrl,
                      altText,
                      buttonText,
                      buttonRedirectText,
                      cardId,
                      isMembershipCard,
                      membershipCardModalData
                    }) => (
                      <CardItemContainer
                        removeRightMargin={false}
                        isMembershipCard={isMembershipCard}
                      >
                        <CardContainer>
                          <CardImage
                            onClick={isMembershipCard ? this.handleClick : null}
                            src={imageUrl}
                            alt={altText}
                            id={cardId}
                          />
                        </CardContainer>
                        {buttonText && (
                          <KnowMoreButton
                            as="a"
                            href={buttonRedirectText}
                            target="_blank"
                          >
                            {buttonText}
                          </KnowMoreButton>
                        )}
                        {isMembershipCard
                          ? this.renderMembershipModal(membershipCardModalData)
                          : null}
                      </CardItemContainer>
                    )
                  )}
                </Slider>
              </DesktopSlider>

              <NextArrowSection
                id="price-card-next-arrow"
                onClick={
                  testimonialIndex >= testimonialMaxIndexLimit
                    ? null
                    : this.next
                }
              >
                <PriceCardNextSvgContainer
                  disableArrow={testimonialIndex >= testimonialMaxIndexLimit}
                >
                  <PriceCardsArrow />
                </PriceCardNextSvgContainer>
              </NextArrowSection>
            </SliderContainer>
          ) : (
            <SliderContainer>
              <DesktopCardsWrapper
                alignCenter={priceCardsDesktopImagesList.length < 3}
              >
                {priceCardsDesktopImagesList.map(
                  ({
                    imageUrl,
                    altText,
                    buttonText,
                    buttonRedirectText,
                    cardId,
                    isMembershipCard,
                    membershipCardModalData
                  }) => (
                    <CardItemContainer
                      removeRightMargin
                      isMembershipCard={isMembershipCard}
                    >
                      <CardContainer>
                        <CardImage
                          onClick={isMembershipCard ? this.handleClick : null}
                          src={imageUrl}
                          alt={altText}
                          id={cardId}
                        />
                      </CardContainer>
                      {buttonText && (
                        <KnowMoreButton
                          as="a"
                          href={buttonRedirectText}
                          target="_blank"
                        >
                          {buttonText}
                        </KnowMoreButton>
                      )}
                      {isMembershipCard
                        ? this.renderMembershipModal(membershipCardModalData)
                        : null}
                    </CardItemContainer>
                  )
                )}
              </DesktopCardsWrapper>
            </SliderContainer>
          )}
        </PriceCardsContainer>
      </PriceCardsSection>
    )
  }
}

export default DesktopPriceCards



// WEBPACK FOOTER //
// ./src/components/IbcArcade/PriceCards/index.desktop.js